<template>
  <div
    class="my-3"
    style="width: 750px; margin-left: auto; margin-right: 250px"
  >
    <v-container
      style="max-height: 250px; overflow-y: scroll"
      class="scrollDesign"
      max-width="1150px"
      scrollable
    >
      <v-data-table
        :headers="parentsHeaders"
        :items="parents"
        hide-details
        hide-actions
        class="child custom-border"
        style="max-height: 250px; overflow-y: scroll"
      >
        <template v-slot:headers="props">
          <tr>
            <th
              v-for="header of props.headers"
              style="min-width: 250px"
              :key="header.text"
            >
              {{ $t(header.langKey) }}
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <td style="width: 250px; max-width: 250px; min-width: 250px">
            {{ props.item.firstName }}
          </td>
          <td style="width: 250px; max-width: 250px; min-width: 250px">
            {{ props.item.lastName }}
          </td>
          <td style="width: 250px; max-width: 250px; min-width: 250px">
            {{ props.item.email }}
          </td>
          <td style="width: 250px; max-width: 250px; min-width: 250px">
            <v-btn flat fab @click="editParent(props.item)">
              <v-icon class="no-border">edit_note</v-icon>
            </v-btn>
          </td>
        </template>
      </v-data-table>
      <TutorModal
        :class="!modals.parent ? 'position-no' : ''"
        :title="modals.title"
        v-model="modals.parent"
        :parent="select.parent"
        @parentchange="onParent"
        @parentchangeUp="onParentUp"
      ></TutorModal>
    </v-container>
  </div>
</template>
<script>
import TutorModal from '../../../Modals/TutorModalUp.vue'
export default {
  components: {
    TutorModal,
  },
  props: ['parents', 'flags'],
  data: () => ({
    modals: {
      parent: false,
    },
    select: {
      parent: null,
    },
    parentsHeaders: [
      {
        text: 'Nombre',
        sortable: false,
        value: 'firstName',
        align: 'center',
        sortable: true,
        langKey:
          'students.massive_upload.step_3.table.parent_detail.first_name',
      },
      {
        text: 'Apellidos',
        sortable: false,
        value: 'lastName',
        align: 'center',
        sortable: true,
        langKey: 'students.massive_upload.step_3.table.parent_detail.last_name',
      },
      {
        text: 'Correo',
        sortable: false,
        value: 'mail',
        align: 'center',
        sortable: true,
        langKey: 'students.massive_upload.step_3.table.parent_detail.email',
      },
      {
        text: 'Editar',
        sortable: false,
        align: 'center',
        sortable: true,
        langKey: 'students.massive_upload.step_3.table.parent_detail.edit',
      },
    ],
    generalKey: 0,
  }),
  methods: {
    editParent(parent) {
      this.select.parent = parent
      this.modals.parent = true
      this.modals.title = this.$t(
        'students.massive_upload.step_3.table.parent_detail.edit_parent_modal.edit_tutor'
      )
    },
    onParent(val) {
      this.parents.splice(this.parents.indexOf(this.select.parent), 1)
      this.parents.push(val)
      this.modals.parent = false
      this.select.parent = null
      this.selected = []
      this.$emit('parent', val)
    },
    onParentUp(val) {
      this.parents.splice(this.parents.indexOf(this.select.parent), 1)
      this.parents.push(val)
      this.modals.parent = false
      this.select.parent = null
      this.selected = []

      this.$emit('parentUp', this.parents)
    },
  },
}
</script>

<style>
.expandableContainer {
  border-style: solid;
  border-color: #e6e6e6;
  border-radius: 15px;
  border-width: 2px;
}
</style>

<style scoped>
.custom-border {
  border-radius: 0.5rem;
  border: 1px solid #ccc !important;
}
::v-deep .child .v-table__overflow {
  overflow-x: scroll !important;
}
</style>
